export enum TourKeys {
  PredictiveScaling = 'predictive-scaling-tour',
  WOOP = 'woop-events-tour',
  OpinionatedPlatform = 'opinionated-platform-tour',
}
